/**
 * EHV-750: intercept POST /templates/render for ETV protocol attendance / signature list PDFs.
 * Injects an "Anzahl Einheiten" column, sums MEA and unit counts, and appends a Gesamt row.
 * Inner fetch layer below luxFetchDispatcher. Loads first among feature fetch patches (gulp order).
 */
;(function setupTemplateInjectionOwnersMeetingAttendanceList() {
  const originalFetch = window.fetch
  const RENDER_PATH = '/services/pmp-document/api/v1/templates/render'
  const MARK_ATTR = 'data-lux-ehv-750'

  function parseGermanDecimal(text) {
    if (text == null) return 0
    let t = String(text).trim().replace(/\s/g, '')
    if (!t) return 0
    let neg = false
    if (t.startsWith('-')) {
      neg = true
      t = t.replace(/^-\s*/, '')
    }
    const normalized = t.replace(/\./g, '').replace(',', '.')
    const n = parseFloat(normalized)
    if (!Number.isFinite(n)) return 0
    return neg ? -n : n
  }

  function formatMeaGerman(value) {
    const abs = Math.abs(value)
    const fixed = abs.toFixed(5)
    const parts = fixed.split('.')
    const intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    const decPart = parts[1] || '00000'
    const s = intPart + ',' + decPart
    return value < 0 ? '- ' + s : s
  }

  /** Einheiten cell: unit numbers separated by comma or newline → count of owned units. */
  function countUnitsFromEinheitenCell(text) {
    if (!text || typeof text !== 'string') return 0
    const parts = text
      .split(/[,\n]+/)
      .map(function (s) {
        return s.trim()
      })
      .filter(Boolean)
    return parts.length
  }

  function findAttendanceTable(doc) {
    const root = doc.getElementById('OwnersMeetingProtocolAttendance')
    if (!root) return null
    const wrap = root.querySelector('.ProtocolAttendeesTable')
    const table = (wrap && wrap.querySelector('table')) || root.querySelector('table')
    return table || null
  }

  function patchAttendanceListHtml(html) {
    if (typeof html !== 'string' || html.indexOf('OwnersMeetingProtocolAttendance') === -1) {
      return null
    }
    let parser = null
    try {
      parser = new DOMParser()
    } catch (e) {
      return null
    }
    const doc = parser.parseFromString(html, 'text/html')
    const table = findAttendanceTable(doc)
    if (!table) return null

    const theadRow = table.querySelector('thead tr')
    const tbody = table.querySelector('tbody')
    if (!theadRow || !tbody) return null

    if (theadRow.querySelector('th[' + MARK_ATTR + ']')) {
      return null
    }

    const headerCells = theadRow.querySelectorAll('th')
    if (headerCells.length < 4) return null

    const EINHEITEN_IDX = 2
    const MEA_IDX = 3
    const meaTh = headerCells[MEA_IDX]
    if (!meaTh) return null

    const newTh = doc.createElement('th')
    newTh.className = 'ant-table-cell'
    newTh.setAttribute(MARK_ATTR, '1')
    newTh.textContent = 'Anzahl Einheiten'
    theadRow.insertBefore(newTh, meaTh)

    const bodyRows = tbody.querySelectorAll('tr.ant-table-row')
    let sumMea = 0
    let sumUnits = 0

    bodyRows.forEach(function (tr) {
      const tds = tr.querySelectorAll('td')
      if (tds.length <= MEA_IDX) return
      const einheitenTd = tds[EINHEITEN_IDX]
      const meaTd = tds[MEA_IDX]
      const unitCount = countUnitsFromEinheitenCell(einheitenTd ? einheitenTd.textContent : '')
      sumUnits += unitCount
      const meaSpan = meaTd.querySelector('.AmountTypography') || meaTd
      sumMea += parseGermanDecimal(meaSpan.textContent || '')

      const newTd = doc.createElement('td')
      newTd.className = 'ant-table-cell'
      newTd.textContent = String(unitCount)
      tr.insertBefore(newTd, meaTd)
    })

    const colgroup = table.querySelector('colgroup')
    if (colgroup) {
      const cols = colgroup.querySelectorAll('col')
      const meaCol = cols[MEA_IDX]
      if (meaCol) {
        const newCol = doc.createElement('col')
        newCol.setAttribute('style', 'width: 9%;')
        colgroup.insertBefore(newCol, meaCol)
      }
    }

    const tfoot = doc.createElement('tfoot')
    tfoot.className = 'ant-table-summary'
    const sumTr = doc.createElement('tr')
    const td0 = doc.createElement('td')
    td0.className = 'ant-table-cell'
    const td1 = doc.createElement('td')
    td1.className = 'ant-table-cell'
    td1.innerHTML = '<strong>Gesamt</strong>'
    const td2 = doc.createElement('td')
    td2.className = 'ant-table-cell'
    const td3 = doc.createElement('td')
    td3.className = 'ant-table-cell'
    td3.innerHTML = '<strong>' + String(sumUnits) + '</strong>'
    const td4 = doc.createElement('td')
    td4.className = 'ant-table-cell column-align-right'
    td4.innerHTML =
      '<span class="AmountTypography property-share ">' + formatMeaGerman(sumMea) + '</span>'
    const td5 = doc.createElement('td')
    td5.className = 'ant-table-cell'
    const td6 = doc.createElement('td')
    td6.className = 'ant-table-cell'
    sumTr.appendChild(td0)
    sumTr.appendChild(td1)
    sumTr.appendChild(td2)
    sumTr.appendChild(td3)
    sumTr.appendChild(td4)
    sumTr.appendChild(td5)
    sumTr.appendChild(td6)
    tfoot.appendChild(sumTr)
    table.appendChild(tfoot)

    return '<!DOCTYPE html>\n' + doc.documentElement.outerHTML
  }

  function tryPatchTemplatesRenderBody(bodyStr) {
    if (typeof bodyStr !== 'string' || !bodyStr) return null
    let parsed
    try {
      parsed = JSON.parse(bodyStr)
    } catch (e) {
      return null
    }
    const html = parsed.html
    const nextHtml = patchAttendanceListHtml(html)
    if (!nextHtml) return null
    parsed.html = nextHtml
    return JSON.stringify(parsed)
  }

  window.fetch = async function (url, options) {
    const opts = options === undefined ? {} : options
    const urlString = typeof url === 'string' ? url : url && url.url ? url.url : String(url)

    if (urlString.indexOf(RENDER_PATH) === -1) {
      return originalFetch.apply(this, arguments)
    }

    const methodNorm = String(
      opts.method || (typeof url !== 'string' && url && url.method) || 'GET'
    ).toUpperCase()
    if (methodNorm !== 'POST') {
      return originalFetch.apply(this, arguments)
    }

    let bodyStr = opts.body
    if ((bodyStr == null || bodyStr === '') && typeof url !== 'string' && url instanceof Request) {
      try {
        bodyStr = await url.clone().text()
      } catch (e) {
        return originalFetch.apply(this, arguments)
      }
    }

    const newBody = tryPatchTemplatesRenderBody(bodyStr)
    if (!newBody) {
      return originalFetch.apply(this, arguments)
    }

    if (typeof url === 'string') {
      return originalFetch(url, Object.assign({}, opts, { body: newBody }))
    }
    if (url instanceof Request) {
      return originalFetch(url.url, {
        method: url.method,
        headers: url.headers,
        body: newBody,
        credentials: url.credentials,
        mode: url.mode,
        cache: url.cache,
        redirect: url.redirect,
        referrer: url.referrer,
        integrity: url.integrity,
      })
    }

    return originalFetch.apply(this, arguments)
  }
})()
